import {
  atkVsOdiContestListByCategory,
  cfcVsBfcContestListByCategory,
  jfcVsMcfMyContestListByCategory,
  kerVsNorContestListByCategory
} from './fantasy_football_contest_by_category';
import {
  atkMBVsCfcLeaderboardList,
  atkVsOdiLeaderboardData,
  cfcVsBfcResultLeaderboardList,
  jfcVsMcfLeaderBoardData,
  kerVsNorLeaderBoardData,
  odiVsBfcLeaderboardList
} from './fantasy_football_leaderboarddata';
import {
  atkVsCfcMatch,
  atkVsOdiMatch,
  jfcVsMcfMatch,
  kfcVsNeUtdMatch
} from './fantasy_football_matches';
import {
  atkMBVsCfcMyContestList,
  atkVsOdiMyContestList,
  cfcVsBfcMyContestList,
  cfcVsBfcResultMyContestList,
  jfcVsMcfMyContestList,
  kerVsNorMyContestList,
  odiVsBfcMyContestList
} from './fantasy_football_mycontestlist';
import {
  atkMBVsCfcMyTeamsList,
  atkVsOdiMyTeamsList,
  cfcVsBfcMyTeamsList,
  cfcVsBfcResultMyTeamsList,
  jfcVsMcfMyTeamsList,
  kerVsNorMyTeamsList,
  odiVsBfcMyTeamsList
} from './fantasy_football_myteamsList';
import {
  atkMBVsCfcPlayerList,
  atkVsOdiPlayerList,
  cfcVsBfcPlayerList,
  cfcVsBfcResultPlayersList,
  jfcVsMcfMyPlayerList,
  kerVsNorPlayerList,
  odiVsBfcPlayerList
} from './fantasy_football_playerlist';

export const fantasyFootballFixtureList = [
  {
    _id: '63cc15606bc8d3ddb98f5086',
    apiMatchId: '174290',
    awayTeam: {
      tid: '453',
      tname: 'Chennaiyin',
      logo: 'https://soccer.entitysport.com/assets/team/453.png',
      fullname: 'Chennaiyin FC',
      abbr: 'CHE'
    },
    competition: {
      cid: '872',
      cname: 'Indian Super League',
      startdate: '2022-10-07 00:00:00',
      enddate: '2023-03-31 00:00:00',
      startdatetimestamp: '1665100800',
      endtdatetimestamp: '1680220800',
      year: '22/23',
      category: 'India',
      tournament_id: '16',
      category_id: '14',
      ioc: 'in',
      status: '3',
      status_str: 'live',
      logo: ''
    },
    createdOn: '2023-01-21T16:40:00.038Z',
    endDate: '2023-01-28T19:00:00.000Z',
    formatString: 'Indian Super League',
    gameState: 1,
    gameStateText: 'Not started',
    homeTeam: {
      tid: '451',
      tname: 'Bengaluru',
      logo: 'https://soccer.entitysport.com/assets/team/451.png',
      fullname: 'Bengaluru FC',
      abbr: 'BFC'
    },
    lineupsOut: false,
    modifiedOn: '2023-01-25T11:50:00.026Z',
    preSquad: true,
    result: {
      home: '0',
      away: '0',
      winner: ''
    },
    round: '17',
    startDate: '2023-01-28T12:00:00.000Z',
    status: 1,
    statusText: 'upcoming',
    timestampEnd: 1674932400,
    timestampStart: 1674907200,
    title: 'Bengaluru vs Chennaiyin',
    venue: {
      venueid: '433',
      name: 'Sree Kanteerava Stadium',
      location: 'Bangalore, India',
      founded: '1997',
      capacity: '24000',
      googlecoords: '12.969556,77.593469'
    },
    verified: false,
    isContestListed: true
  },
  jfcVsMcfMatch,
  atkVsOdiMatch,
  kfcVsNeUtdMatch
];
export const fantasyFootballLiveList = [atkVsCfcMatch];
export const fantasyFootballResultList = [
  {
    _id: '6352d31ce1e4df00fa125db2',
    apiMatchId: '174223',
    awayTeam: {
      tid: '451',
      tname: 'Bengaluru',
      logo: 'https://soccer.entitysport.com/assets/team/451.png',
      fullname: 'Bengaluru FC',
      abbr: 'BFC'
    },
    competition: {
      cid: '872',
      cname: 'Indian Super League',
      startdate: '2022-10-07 00:00:00',
      enddate: '2023-03-31 00:00:00',
      startdatetimestamp: '1665100800',
      endtdatetimestamp: '1680220800',
      year: '22/23',
      category: 'India',
      tournament_id: '16',
      category_id: '14',
      ioc: 'in',
      status: '3',
      status_str: 'live',
      logo: ''
    },
    createdOn: '2022-10-21T17:13:00.324Z',
    endDate: '2022-10-27T15:53:35.000Z',
    formatString: 'Indian Super League',
    gameState: 6,
    gameStateText: 'Ended',
    homeTeam: {
      tid: '454',
      tname: 'Odisha',
      logo: 'https://soccer.entitysport.com/assets/team/454.png',
      fullname: 'Odisha FC',
      abbr: 'ODI'
    },
    lineupsOut: true,
    modifiedOn: '2022-10-27T18:24:01.117Z',
    preSquad: true,
    result: {
      home: '1',
      away: '0',
      winner: 'home'
    },
    round: '4',
    startDate: '2022-10-27T14:00:00.000Z',
    status: 2,
    statusText: 'result',
    timestampEnd: 1666886015,
    timestampStart: 1666879200,
    title: 'Odisha vs Bengaluru',
    venue: {
      venueid: '1308',
      name: 'Kalinga Stadium',
      location: 'Bhubaneswar, India',
      founded: '',
      capacity: '15000',
      googlecoords: '20.290917, 85.824991'
    },
    verified: true,
    isContestListed: true
  },
  {
    _id: '63445a1c746a9884afab2c59',
    apiMatchId: '174215',
    awayTeam: {
      tid: '451',
      tname: 'Bengaluru',
      logo: 'https://soccer.entitysport.com/assets/team/451.png',
      fullname: 'Bengaluru FC',
      abbr: 'BFC'
    },
    competition: {
      cid: '872',
      cname: 'Indian Super League',
      startdate: '2022-10-07 00:00:00',
      enddate: '2023-03-31 00:00:00',
      startdatetimestamp: '1665100800',
      endtdatetimestamp: '1680220800',
      year: '22/23',
      category: 'India',
      tournament_id: '16',
      category_id: '14',
      ioc: 'in',
      status: '3',
      status_str: 'live',
      logo: ''
    },
    createdOn: '2022-10-10T17:45:00.325Z',
    endDate: '2022-10-14T15:54:49.000Z',
    formatString: 'Indian Super League',
    gameState: 6,
    gameStateText: 'Ended',
    homeTeam: {
      tid: '453',
      tname: 'Chennaiyin',
      logo: 'https://soccer.entitysport.com/assets/team/453.png',
      fullname: 'Chennaiyin FC',
      abbr: 'CHE'
    },
    lineupsOut: true,
    modifiedOn: '2022-10-14T18:48:00.963Z',
    preSquad: true,
    result: {
      home: '1',
      away: '1',
      winner: 'draw'
    },
    round: '2',
    startDate: '2022-10-14T14:00:00.000Z',
    status: 2,
    statusText: 'result',
    timestampEnd: 1665762889,
    timestampStart: 1665756000,
    title: 'Chennaiyin vs Bengaluru',
    venue: {
      venueid: '1021',
      name: 'Jawaharlal Nehru Stadium',
      location: 'Chennai, India',
      founded: '1993',
      capacity: '40000',
      googlecoords: '13.085556,80.271667'
    },
    verified: true,
    isContestListed: true,
    description: {
      short: 'mega match!',
      long: 'mega'
    }
  }
];

export const fantasyFootballContestListByCategory = {
  '63cc15606bc8d3ddb98f5086': cfcVsBfcContestListByCategory,
  '63cb03286bc8d3ddb965e21b': jfcVsMcfMyContestListByCategory,
  '63d29ad46bc8d3ddb9782e01': kerVsNorContestListByCategory,
  '63cda4c06bc8d3ddb9c91f39': atkVsOdiContestListByCategory
};
export const fantasyFootballMyTeamsList = {
  '63cc15606bc8d3ddb98f5086': cfcVsBfcMyTeamsList,
  '6352d31ce1e4df00fa125db2': odiVsBfcMyTeamsList,
  '63445a1c746a9884afab2c59': cfcVsBfcResultMyTeamsList,
  '633ec64c746a9884af15dc05': atkMBVsCfcMyTeamsList,
  '63cb03286bc8d3ddb965e21b': jfcVsMcfMyTeamsList,
  '63d29ad46bc8d3ddb9782e01': kerVsNorMyTeamsList,
  '63cda4c06bc8d3ddb9c91f39': atkVsOdiMyTeamsList
};
export const fantasyFootballInitialPlayerList = {
  '63cc15606bc8d3ddb98f5086': cfcVsBfcPlayerList,
  '6352d31ce1e4df00fa125db2': odiVsBfcPlayerList,
  '63445a1c746a9884afab2c59': cfcVsBfcResultPlayersList,
  '633ec64c746a9884af15dc05': atkMBVsCfcPlayerList,
  '63cb03286bc8d3ddb965e21b': jfcVsMcfMyPlayerList,
  '63d29ad46bc8d3ddb9782e01': kerVsNorPlayerList,
  '63cda4c06bc8d3ddb9c91f39': atkVsOdiPlayerList
};
export const fantasyFootballMyContestList = {
  '63cc15606bc8d3ddb98f5086': cfcVsBfcMyContestList,
  '6352d31ce1e4df00fa125db2': odiVsBfcMyContestList,
  '63445a1c746a9884afab2c59': cfcVsBfcResultMyContestList,
  '633ec64c746a9884af15dc05': atkMBVsCfcMyContestList,
  '63cb03286bc8d3ddb965e21b': jfcVsMcfMyContestList,
  '63d29ad46bc8d3ddb9782e01': kerVsNorMyContestList,
  '63cda4c06bc8d3ddb9c91f39': atkVsOdiMyContestList
};

export const fantasyFootballLeaderBoardList = {
  '6352d31ce1e4df00fa125db2': odiVsBfcLeaderboardList,
  '63cc15606bc8d3ddb98f5086': cfcVsBfcResultLeaderboardList,
  '63445a1c746a9884afab2c59': cfcVsBfcResultLeaderboardList,
  '633ec64c746a9884af15dc05': atkMBVsCfcLeaderboardList,
  '63cb03286bc8d3ddb965e21b': jfcVsMcfLeaderBoardData,
  '63d29ad46bc8d3ddb9782e01': kerVsNorLeaderBoardData,
  '63cda4c06bc8d3ddb9c91f39': atkVsOdiLeaderboardData
};
